<template>
    <div class="module">
        <helpinfo :helpData="helpData" />
        <rcTable :tableAttr="tableAttr"
                 ref="rcTable"
                 class="module-container">
            <Button slot="tootipL"
                    @click="refresh">
                <i class="icon-refresh-o-2"></i>
            </Button>
        </rcTable>
    </div>
</template>
<script>
import helpinfo from '@/views/components/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api.js'
export default {
    name: 'usercontract',
    components: {
        helpinfo,
        rcTable
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('我的合同'),
                showBack: false
            },
            statusObj: {
                unused: '未使用',
                audit_executing: '执行中',
                terminated: '合同终止',
                expired: '合同过期'
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.CONTRACT),
                    params: {
                        orgSid: this.$store.state.user.currentOrg.orgSid
                    }
                },
                searchColumns: [
                    {
                        key: 'contractId',
                        title: this.$t('合同ID'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'contractTitleLike',
                        title: this.$t('合同名称'),
                        searchDefaultValue: ''
                    }
                    // {
                    //     key: 'contractStatus',
                    //     title: this.$t('状态'),
                    //     searchDefaultValue: '',
                    //     searchType: 'select',
                    //     searchData: [
                    //         {
                    //             value: 'audit_executing',
                    //             name: this.$t('执行中')
                    //         },
                    //         {
                    //             value: 'terminated',
                    //             name: this.$t('合同终止')
                    //         }
                    //     ]
                    // }
                ],
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                referenceVal: 1200,
                columns: [
                    {
                        title: this.$t('合同ID'),
                        key: 'contractId',
                        className: 'tbl-operate',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        width: 150,
                        resizable: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('a', {
                                on: { click: () => this.detail(params.row) },
                                class: 'tbl-operate'
                            }, params.row.contractId)
                        }
                    },
                    {
                        title: this.$t('合同名称'),
                        key: 'contractTitle',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        width: 100,
                        resizable: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.contractTitle } }, this.$t(params.row.contractTitle))
                        }
                    },
                    {
                        title: `${this.$t('合同金额')}`,
                        key: 'amount',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        width: 130,
                        resizable: true,
                        align: 'right',
                        render: (h, params) => {
                            const money = this.$money(params.row.amount)
                            return h('span', { attrs: { title: money }, class: 'balance-color', style: 'padding-right: 20px;' }, money)
                        }
                    },
                    {
                        title: `${this.$t('信用余额')}`,
                        key: 'credit',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        width: 130,
                        resizable: true,
                        align: 'right',
                        render: (h, params) => {
                            const money = this.$money(params.row.credit)
                            return h('span', { attrs: { title: money }, class: 'balance-color', style: 'padding-right: 20px;' }, money)
                        }
                    },
                    {
                        title: this.$t('合同签订时间'),
                        key: 'signedTime',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 130,
                        render: (h, params) => h('span', { attrs: { title: params.row.signedTime } }, params.row.signedTime)
                    },
                    {
                        title: this.$t('合同开始时间'),
                        key: 'startTime',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        width: 130,
                        resizable: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.startTime || '--' } }, params.row.startTime || '--')
                        }
                    },
                    {
                        title: this.$t('合同结束时间'),
                        key: 'endTime',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        minWidth: 150,
                        resizable: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.endTime || '--' } }, params.row.endTime || '--')
                        }
                    },
                    {
                        title: this.$t('备注'),
                        key: 'decription',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: false,
                        width: 180,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.decription } }, params.row.decription)
                    },
                    {
                        title: this.$t('状态'),
                        key: 'contractStatus',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: false,
                        columnsChoosed: true,
                        // width: 100,
                        resizable: true,
                        filterMultiple: false,
                        width: 120,
                        filters: [
                            {
                                value: 'unused',
                                label: this.$t('未使用')
                            },
                            {
                                value: 'audit_executing',
                                label: this.$t('执行中')
                            },
                            {
                                value: 'terminated',
                                label: this.$t('合同终止')
                            },
                            {
                                value: 'expired',
                                label: this.$t('合同过期')
                            }
                        ],
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.contractStatus,
                                    stateName: this.$t(this.statusObj[params.row.contractStatus])
                                }
                            })
                        }
                    }
                    // {
                    //     title: this.$t('操作'),
                    //     width: 80,
                    //     resizable: true,
                    //     fixed: 'right',
                    //     // align: 'center',
                    //     render: (h, params) => h('a', { on: { click: () => this.detail(params.row) } }, this.$t('详情'))
                    // }
                ]
            }
        }
    },
    created () { },
    methods: {
        refresh () {
            this.$refs.rcTable.refreshTable()
        },
        detail (item) {
            this.$router.push({
                path: `/mgt/contracts/detail/${item.contractId}`
            })
        }
    }
}
</script>
